export default {"src":"/_next/static/media/pinterest.72d3ddee.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};